import { VIZ_CATEGORICAL } from '@splunk/visualization-color-palettes';
import { COLOR_OR_TOKEN_PATTERN_WITH_RGBA, enhanceOptionsSchemaWithDynamicOptions } from '../utils';

export const parallelCoordinatesOptionsSchema = enhanceOptionsSchemaWithDynamicOptions({
    backgroundColor: {
        default: '> themes.defaultBackgroundColor',
        description:
            'Specify the color used for the background. The default for enterprise light is "#FFFFFF". The default for enterprise dark is "#000000". The default for prisma dark is "#0b0c0e".',
        pattern: COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
        type: 'string',
    },
    lineColor: {
        default: VIZ_CATEGORICAL[0],
        description: 'Specify the dataSource color for the lines. The hex value format should be #FFFFFF.',
        pattern: COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
        type: 'string',
    },
    lineOpacity: {
        default: 0.5,
        description:
            'Specify the opacity of the lines. Choose a number in the range of 0 - 1 (inclusive). You can also express the value as a percentage. For example, "0.50" in source or "50%" in UI.',
        type: 'number',
    },
    showNullAxis: {
        default: true,
        description: 'Select whether you would like to show or hide the null value axis.',
        type: 'boolean',
    },
});
